import { ILokalplan } from '../Interfaces/ILokalplan';

/**
 * Takes a string of comma-separated values and returns array
 * @param input Comma-separated string of values to output. May be surrounded by square brackets.
 * @returns Array of values
 */
export function arrayStringToArray(input: string): Array<any> {
  if (!input) {
    return [];
  }
  return input
    .replace('[', '')
    .replace(']', '')
    .split(',');
}

export function dateNumberToDate(input: number): Date {
  if (!input) {
    return undefined;
  }
  const dateString = input.toString();
  return new Date(
    dateString.substr(0, 4) +
      '-' +
      dateString.substr(4, 2) +
      '-' +
      dateString.substr(6, 2)
  );
}

export function lokalplanArraysAreEqual(
  array1: Array<ILokalplan>,
  array2: Array<ILokalplan>
): Boolean {
  if (array1.length !== array2.length) return false;
  const planids1 = array1.map(a => a.feature.properties.planid).sort();
  const planids2 = array2.map(a => a.feature.properties.planid).sort();
  for (let i = 0; i < planids1.length; i++) {
    if (planids1[i] !== planids2[i]) return false;
  }
  return true;
}
export function hoveredplanArraysAreEqual(
  array1: Array<number>,
  array2: Array<number>
): Boolean {
  if (array1.length !== array2.length) return false;
  const planids1 = array1.sort();
  const planids2 = array2.sort();
  for (let i = 0; i < planids1.length; i++) {
    if (planids1[i] !== planids2[i]) return false;
  }
  return true;
}

/*
https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Avoiding_user_agent_detection
*/
export function isTouchDevice() {
  let hasTouchScreen = false;
  const { navigator } = window;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = (navigator as any).msMaxTouchPoints > 0;
  } else {
    var mQ = window.matchMedia && matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // depedicated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      var UA = (navigator as any).userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
}

export function datePropertyToDateString(input: string) {
  const year = input.substr(0, 4);
  const month = input.substr(5, 2);
  const day = input.substr(8, 2);
  return `${day}.${month}.${year}`;
}
export function datePropertyToTimeString(input: string) {
  return input.substr(11, 2) + ':' + input.substr(14, 2);
}
